import React, { useState, useEffect } from "react";
import { ReactComponent as EnvelopeFill } from "images/cannedmessage/envelope-fill.svg";
import TabbedView from "components/TabbedView/TabbedView";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { MessagesTab } from "constants/ChatViewConstants";
import CannedMessages from "components/CannedMessages/CannedMessages";
import { AiFillBulb } from "react-icons/ai";
import { MdLocationOn } from "react-icons/md";
import { connect } from "react-redux";
import "./CannedAndSuggestionsView.scss";
import MessageSuggestionService from "services/MessageSuggestionService";
import { setSuggestionMessage } from "actions/suggestionActions";
import Suggestions from "components/Suggestions/Suggestions";
import _colors from "styles/colors.module.scss";
import { getBusinessUnit, getGroup } from "utils/Common";
import { UserBU, UserGroup } from "constants/UserConstants";
import DealerLocation from "components/DealerLocation/DealerLocation";
import DealerLocationTabService from "services/DealerLocationTabService";
import { Tooltip } from "react-tooltip";

const { lightOrange } = _colors;
const tooltipStyle = { background: "black", color: "white" };

function CannedAndSuggestionsView(props) {
  const [activeTab, setActiveTab] = useState(MessagesTab.CANNED_MESSAGES);
  const isActiveSuggestionShown = props.activeSuggestion !== null;
  const suggestionHeaderColors = {
    bulb: "#fff",
    bgColor: lightOrange,
  };
  const onSuggestionPrompt = (message) => {
    props.setSuggestionMessage(message);
    if (!message || message === null) {
      setActiveTab(MessagesTab.CANNED_MESSAGES);
    } else {
      setActiveTab(MessagesTab.SUGGESTIONS);
    }
  };

  const onLocationPrompt = () => {
    setActiveTab(MessagesTab.DEALER_LOCATIONS);
  };

  const onTabChange = (tab) => {
    setActiveTab(tab);
  };

  const userBusinessUnit = getBusinessUnit();
  const userBUGroup = getGroup();

  useEffect(() => {
    const suggestionsSubscription = MessageSuggestionService.listen().subscribe(
      onSuggestionPrompt
    );
    const dealerTabServiceSubscription = DealerLocationTabService.listen().subscribe(
      onLocationPrompt
    );

    return () => {
      if (suggestionsSubscription) {
        suggestionsSubscription.unsubscribe();
      }
      if (dealerTabServiceSubscription) {
        dealerTabServiceSubscription.unsubscribe();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const tabs = [
    {
      value: MessagesTab.CANNED_MESSAGES,
      header: (
        <div className="tab-header canned-msg-header">
          <div className="tab-icon">
            <Tooltip id="tabIconTipCanned" className="tool-tip" style={tooltipStyle} disableStyleInjection="core" />
            <IconWithBackground
              icon={<EnvelopeFill />}
              data-tooltip-id="tabIconTipCanned"
              data-tooltip-content="Canned Messages"
              data-tooltip-hidden={activeTab === MessagesTab.CANNED_MESSAGES}
            />
          </div>
          <div className="header-text">Canned Messages</div>
        </div>
      ),
      content: <CannedMessages />,
    },
  ];
  if (
    (userBusinessUnit === UserBU.CV && userBUGroup === UserGroup.SERVICE) ||
    (userBusinessUnit === UserBU.PV && userBUGroup === UserGroup.SALES)
  ) {
    tabs.push({
      value: MessagesTab.DEALER_LOCATIONS,
      header: (
        <div className="tab-header suggestions-header">
          <div className="tab-icon">
            <Tooltip id="tabIconTipDealer" className="tool-tip" style={tooltipStyle} disableStyleInjection="core" />
            <IconWithBackground
              icon={<MdLocationOn color="white" size="1em" />}
              data-tooltip-id="tabIconTipDealer"
              data-tooltip-content="Dealer Locations"
              data-tooltip-hidden={activeTab === MessagesTab.DEALER_LOCATIONS}
            />
          </div>
          <div className="header-text">Dealer Location</div>
        </div>
      ),
      content: <DealerLocation />,
    });
    if (userBusinessUnit === UserBU.PV) {
      tabs.push({
        value: MessagesTab.SUGGESTIONS,
        header: (
          <div className="tab-header suggestions-header">
            <div className="tab-icon">
              <Tooltip id="tabIconTipSuggestions" className="tool-tip" style={tooltipStyle} disableStyleInjection="core" />
              <IconWithBackground
                icon={<AiFillBulb color={suggestionHeaderColors.bulb} />}
                backgroundColor={suggestionHeaderColors.bgColor}
                data-tooltip-id="tabIconTipSuggestions"
                data-tooltip-content="Suggestions"
                data-tooltip-hidden={activeTab === MessagesTab.SUGGESTIONS}
              />
            </div>
            <div className="header-text">Suggestions</div>
          </div>
        ),
        content: <Suggestions />,
        disabled: !isActiveSuggestionShown,
      });
    }
  }
  return (
    <TabbedView
      className="canned-suggestions-tabbed-view"
      tabs={tabs}
      activeTab={activeTab}
      data-testid="canned-and-suggestions"
      onChange={onTabChange}
    />
  );
}

const mapDispatchToProps = {
  setSuggestionMessage,
};

const mapStateToProps = (state) => ({
  activeSuggestion: state.suggestion.activeSuggestion,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CannedAndSuggestionsView);
